import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["excludeSystemUser"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { useListAuditLogsQuery, useGetUserQuery } from '~/types/types';
import { getFriendlyTableName } from '~/functions/helpers';
import { useShowDebugging } from '~/functions/accounts';
import { renderAuditLogDiff } from '~/functions/object-diff';
export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLogs',
  props: {
    // Legacy v-model / :value + @input
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // Vue 3-style v-model (modelValue + update:modelValue)
    modelValue: {
      type: Array,
      default: undefined
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['name'];
      }
    },
    defaultFilters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showSelect: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var showDebugging = useShowDebugging();
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    var headers = computed(function () {
      return [{
        value: 'id'
      }, {
        value: 'operationType',
        width: 100
      }, {
        value: 'tableName',
        width: 100
      }, {
        value: 'context',
        width: 300
      }, {
        value: 'change'
      }, {
        value: 'originalData'
      }, {
        value: 'newData'
      }, {
        value: 'dataId'
      }, {
        value: 'createdAt'
      }, {
        value: 'createdBy'
      }, {
        value: 'actions'
      }].filter(function (o) {
        var _props$columns;
        return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.includes(o.value);
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var filters = ref({});
    var variables = computed(function () {
      return _objectSpread(_objectSpread(_objectSpread({}, props.defaultFilters), filters.value), {}, {
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      });
    });
    var _useListAuditLogsQuer = useListAuditLogsQuery(variables),
      result = _useListAuditLogsQuer.result,
      refetch = _useListAuditLogsQuer.refetch,
      loading = _useListAuditLogsQuer.loading;
    expose({
      refetch: refetch
    });
    var createdById = computed(function () {
      var value = filters.value.createdById;
      return Array.isArray(value) ? value : [];
    });
    var hasMeaningfulChange = function hasMeaningfulChange(item) {
      var originalData = (item === null || item === void 0 ? void 0 : item.originalData) || {};
      var newData = (item === null || item === void 0 ? void 0 : item.newData) || {};
      var omitUpdatedAt = function omitUpdatedAt(obj) {
        if (!obj || _typeof(obj) !== 'object') return {};
        var copy = _objectSpread({}, obj);
        delete copy.updated_at;
        return copy;
      };
      return !_.isEqual(omitUpdatedAt(originalData), omitUpdatedAt(newData));
    };
    var items = computed(function () {
      var _result$value$listAud, _result$value;
      return ((_result$value$listAud = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listAuditLogs) !== null && _result$value$listAud !== void 0 ? _result$value$listAud : []).filter(hasMeaningfulChange);
    });

    // Prefer modelValue when provided, fall back to legacy value
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var selected = computed(function () {
      return items === null || items === void 0 ? void 0 : items.value.filter(function (logs) {
        return currentIds.value.filter(Boolean).includes(logs.id || '');
      });
    });
    var search = ref('');
    var onInput = function onInput(val) {
      var nextIds = val.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (_.isEqual(nextIds, currentIds.value)) {
        // if the value is the same, don't fire the event
        return;
      }
      emit('update:modelValue', nextIds);
      emit('input', nextIds);
    };
    var handleExcludeSystemUserChange = function handleExcludeSystemUserChange(value) {
      if (value) {
        filters.value = _objectSpread(_objectSpread({}, filters.value), {}, {
          excludeSystemUser: true
        });
      } else {
        var _filters$value = filters.value,
          excludeSystemUser = _filters$value.excludeSystemUser,
          rest = _objectWithoutProperties(_filters$value, _excluded);
        filters.value = rest;
      }
    };
    var handleCreatedById = function handleCreatedById(value) {
      filters.value = _objectSpread(_objectSpread({}, filters.value), {}, {
        createdById: value
      });
    };
    var formatContextValue = function formatContextValue(value) {
      if (value === null || value === undefined) return '';
      if (Array.isArray(value)) return value.map(function (v) {
        return _typeof(v) === 'object' ? JSON.stringify(v) : String(v);
      }).join(', ');
      if (_typeof(value) === 'object') return JSON.stringify(value);
      return String(value);
    };
    var renderContext = function renderContext(item) {
      var raw = item === null || item === void 0 ? void 0 : item.context;
      if (!raw) return [];
      var ctx;
      if (typeof raw === 'string') {
        try {
          ctx = JSON.parse(raw);
        } catch (_unused) {
          return [{
            key: 'context',
            value: raw
          }];
        }
      } else if (_typeof(raw) === 'object') {
        ctx = raw;
      }
      if (!ctx) return [];
      var isEmpty = function isEmpty(val) {
        if (val === null || val === undefined || val === '') return true;
        if (Array.isArray(val) && val.length === 0) return true;
        if (_typeof(val) === 'object' && Object.keys(val).length === 0) return true;
        return false;
      };
      return Object.keys(ctx).filter(function (k) {
        return k !== 'updated_at' && !isEmpty(ctx[k]);
      }).map(function (key) {
        return {
          key: key,
          value: formatContextValue(ctx[key])
        };
      });
    };
    var getFriendlyOperationType = function getFriendlyOperationType(operationType) {
      var friendlyNames = {
        'UPDATE': 'Update',
        'INSERT': 'Add',
        'DELETE': 'Delete'
      };
      return friendlyNames[operationType] || operationType;
    };
    var getCreatedByMeta = function getCreatedByMeta(createdBy) {
      var email = (createdBy === null || createdBy === void 0 ? void 0 : createdBy.email) || '';
      if (!email) {
        return {
          label: '',
          icon: 'mdi-account',
          color: 'grey lighten-2',
          dark: false
        };
      }
      if (email === '@') {
        return {
          label: 'System User',
          icon: 'mdi-robot',
          color: 'grey darken-1',
          dark: true
        };
      }
      if (createdBy !== null && createdBy !== void 0 && createdBy.isAdmin) {
        var _user$value;
        var label = user !== null && user !== void 0 && (_user$value = user.value) !== null && _user$value !== void 0 && _user$value.isAdmin ? email : 'IX Admin';
        return {
          label: label,
          icon: 'mdi-shield-account',
          color: 'deep-purple',
          dark: true
        };
      }
      return {
        label: email,
        icon: 'mdi-account',
        color: 'primary',
        dark: true
      };
    };
    var formatDate = function formatDate(dateString) {
      if (!dateString) return '';

      // Create date object - the dateString should already be in UTC format
      var date = new Date(dateString);

      // Format using user's local timezone
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    };
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countAuditLogs) || 0;
    });
    return {
      __sfc: true,
      showDebugging: showDebugging,
      props: props,
      emit: emit,
      userResult: userResult,
      user: user,
      headers: headers,
      options: options,
      filters: filters,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      createdById: createdById,
      hasMeaningfulChange: hasMeaningfulChange,
      items: items,
      currentIds: currentIds,
      selected: selected,
      search: search,
      onInput: onInput,
      handleExcludeSystemUserChange: handleExcludeSystemUserChange,
      handleCreatedById: handleCreatedById,
      formatContextValue: formatContextValue,
      renderContext: renderContext,
      getFriendlyOperationType: getFriendlyOperationType,
      getCreatedByMeta: getCreatedByMeta,
      formatDate: formatDate,
      itemCount: itemCount,
      getFriendlyTableName: getFriendlyTableName,
      renderAuditLogDiff: renderAuditLogDiff
    };
  }
});